module.exports = __webpack_public_path__ + "img/megahobby_pc.a760e272.svg";